import { types } from '../actions/cv';
import { sortArrayOfObjectsByDate } from '../utils/helpers';

const initialState = {
  worksHistory: {
    pendingFlag: false,
    error: '',
    response: null
  },
  trainings: {
    pendingFlag: false,
    error: '',
    response: null
  },
  educations: {
    pendingFlag: false,
    error: '',
    response: null
  },
  skills: {
    pendingFlag: false,
    error: '',
    response: null
  },
  updatingError: '',
  updatingPending: false
};

export default function reduce(state = initialState, action) {
  switch (action.type) {
    case types.GET_WORKS_HISTORY_FULFILLED:
      return {
        ...state,
        worksHistory: {
          pendingFlag: false,
          error: '',
          response: sortArrayOfObjectsByDate(action.payload?.Data || [], 'EndDate', 'CurrentlyWorkThere', 'StartDate')
        }
      };
    case types.GET_WORKS_HISTORY_PENDING:
      return {
        ...state,
        worksHistory: {
          pendingFlag: true,
          error: '',
          action
        }
      };
    case types.GET_WORKS_HISTORY_REJECTED:
      return {
        ...state,
        worksHistory: {
          pendingFlag: false,
          error: action.payload.message,
          action
        }
      };
    case types.GET_TRAININGS_FULFILLED:
      return {
        ...state,
        trainings: {
          pendingFlag: false,
          error: '',
          response: action.payload?.Data
        }
      };
    case types.GET_TRAININGS_PENDING:
      return {
        ...state,
        trainings: {
          pendingFlag: true,
          error: '',
          action
        }
      };
    case types.GET_TRAININGS_REJECTED:
      return {
        ...state,
        trainings: {
          pendingFlag: false,
          error: action.payload.message,
          action
        }
      };
    case types.GET_EDUCATIONS_FULFILLED:
      return {
        ...state,
        educations: {
          pendingFlag: false,
          error: '',
          response: sortArrayOfObjectsByDate(action.payload?.Data || [], 'EndDate', 'CurrentlyStudyHere', 'StartDate')
        }
      };
    case types.GET_EDUCATIONS_PENDING:
      return {
        ...state,
        trainings: {
          pendingFlag: true,
          error: '',
          action
        }
      };
    case types.GET_EDUCATIONS_REJECTED:
      return {
        ...state,
        trainings: {
          pendingFlag: false,
          error: action.payload.message,
          action
        }
      };
    case types.GET_SKILLS_FULFILLED:
      return {
        ...state,
        skills: {
          pendingFlag: false,
          error: '',
          response: action.payload?.Data
        }
      };
    case types.GET_SKILLS_PENDING:
      return {
        ...state,
        skills: {
          pendingFlag: true,
          error: '',
          action
        }
      };
    case types.GET_SKILLS_REJECTED:
      return {
        ...state,
        skills: {
          pendingFlag: false,
          error: action.payload.message,
          action
        }
      };
    case types.DELETE_WORK_ITEM_PENDING:
      return { ...state, updatingError: '', updatingPending: true };
    case types.DELETE_WORK_ITEM_REJECTED:
      return { ...state, updatingError: action.payload.message, updatingPending: false };
    case types.DELETE_WORK_ITEM_FULFILLED:
      return {
        ...state,
        updatingPending: false,
        updatingError: '',
        worksHistory: {
          ...state.worksHistory,
          response: state.worksHistory.response.filter((item) => item?.Id !== action.payload.idDeleted)
        }
      };
    case types.ADD_WORK_ITEM_PENDING:
      return { ...state, updatingError: '', updatingPending: true };
    case types.ADD_WORK_ITEM_REJECTED:
      return { ...state, updatingError: action.payload.message, updatingPending: false };
    case types.ADD_WORK_ITEM_FULFILLED:
      return {
        ...state,
        updatingPending: false,
        updatingError: '',
        worksHistory: {
          ...state.worksHistory,
          response: sortArrayOfObjectsByDate(
            [...state.worksHistory.response, { ...action.payload.Data, ...action.payload.newWork }],
            'EndDate',
            'CurrentlyWorkThere',
            'StartDate'
          )
        }
      };
    case types.UPDATE_WORK_ITEM_PENDING:
      return { ...state, updatingError: '', updatingPending: true };
    case types.UPDATE_WORK_ITEM_REJECTED:
      return { ...state, updatingError: action.payload.message, updatingPending: false };
    case types.UPDATE_WORK_ITEM_FULFILLED:
      return {
        ...state,
        updatingPending: false,
        updatingError: '',
        worksHistory: {
          ...state.worksHistory,
          response: sortArrayOfObjectsByDate(
            state.worksHistory.response.map((item) =>
              item.Id !== action.payload.updatedWork.Id ? item : action.payload.updatedWork
            ),
            'EndDate',
            'CurrentlyWorkThere',
            'StartDate'
          )
        }
      };
    case types.DELETE_TRAININGS_ITEM_PENDING:
      return { ...state, updatingError: '', updatingPending: true };
    case types.DELETE_TRAININGS_ITEM_REJECTED:
      return { ...state, updatingError: action.payload.message, updatingPending: false };
    case types.DELETE_TRAININGS_ITEM_FULFILLED:
      return {
        ...state,
        updatingPending: false,
        updatingError: '',
        trainings: {
          ...state.trainings,
          response: state.trainings.response.filter((item) => item?.Id !== action.payload.idDeleted)
        }
      };
    case types.ADD_TRAININGS_ITEM_PENDING:
      return { ...state, updatingError: '', updatingPending: true };
    case types.ADD_TRAININGS_ITEM_REJECTED:
      return { ...state, updatingError: action.payload.message, updatingPending: false };
    case types.ADD_TRAININGS_ITEM_FULFILLED:
      return {
        ...state,
        updatingPending: false,
        updatingError: '',
        trainings: {
          ...state.trainings,
          response: sortArrayOfObjectsByDate(
            [...state.trainings.response, { ...action.payload.Data, ...action.payload.newTraining }],
            'ValidUntil'
          )
        }
      };
    case types.UPDATE_TRAININGS_ITEM_PENDING:
      return { ...state, updatingError: '', updatingPending: true };
    case types.UPDATE_TRAININGS_ITEM_REJECTED:
      return { ...state, updatingError: action.payload.message, updatingPending: false };
    case types.UPDATE_TRAININGS_ITEM_FULFILLED:
      return {
        ...state,
        updatingPending: false,
        updatingError: '',
        trainings: {
          ...state.trainings,
          response: sortArrayOfObjectsByDate(
            state.trainings.response.map((item) =>
              item.Id !== action.payload.updatedTraining.Id ? item : action.payload.updatedTraining
            ),
            'ValidUntil'
          )
        }
      };
    case types.DELETE_EDUCATIONS_ITEM_PENDING:
      return { ...state, updatingError: '', updatingPending: true };
    case types.DELETE_EDUCATIONS_ITEM_REJECTED:
      return { ...state, updatingError: action.payload.message, updatingPending: false };
    case types.DELETE_EDUCATIONS_ITEM_FULFILLED:
      return {
        ...state,
        updatingPending: false,
        updatingError: '',
        educations: {
          ...state.educations,
          response: state.educations.response.filter((item) => item?.Id !== action.payload.idDeleted)
        }
      };
    case types.ADD_EDUCATIONS_ITEM_PENDING:
      return { ...state, updatingError: '', updatingPending: true };
    case types.ADD_EDUCATIONS_ITEM_REJECTED:
      return { ...state, updatingError: action.payload.message, updatingPending: false };
    case types.ADD_EDUCATIONS_ITEM_FULFILLED:
      return {
        ...state,
        updatingPending: false,
        updatingError: '',
        educations: {
          ...state.educations,
          response: sortArrayOfObjectsByDate(
            [...state.educations.response, { ...action.payload.Data, ...action.payload.newEducation }],
            'EndDate',
            'CurrentlyStudyHere',
            'StartDate'
          )
        }
      };
    case types.UPDATE_EDUCATIONS_ITEM_PENDING:
      return { ...state, updatingError: '', updatingPending: true };
    case types.UPDATE_EDUCATIONS_ITEM_REJECTED:
      return { ...state, updatingError: action.payload.message, updatingPending: false };
    case types.UPDATE_EDUCATIONS_ITEM_FULFILLED:
      return {
        ...state,
        updatingPending: false,
        updatingError: '',
        educations: {
          ...state.educations,
          response: sortArrayOfObjectsByDate(
            state.educations.response.map((item) =>
              item.Id !== action.payload.updatedEducation.Id ? item : action.payload.updatedEducation
            ),
            'EndDate',
            'CurrentlyStudyHere',
            'StartDate'
          )
        }
      };
    case types.UPDATE_SKILLS_PENDING:
      return {
        ...state,
        skills: {
          ...state.skills,
          pendingFlag: true
        }
      };
    case types.UPDATE_SKILLS_REJECTED:
      return {
        ...state,
        skills: {
          ...state.skills,
          pendingFlag: false,
          error: action.payload.message
        }
      };
    case types.UPDATE_SKILLS_FULFILLED:
      return {
        ...state,
        skills: {
          ...state.skills,
          pendingFlag: false,
          error: '',
          response: action.payload
        }
      };
    case types.UPLOAD_CV_FULFILLED:
      return {
        ...state,
        uploadedCv: {
          response: action?.payload?.Data
        }
      };

    default:
      return state;
  }
}
